import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL,
  credentials: "include",
});

// 認証トークンをヘッダーに追加するミドルウェア
const authLink = setContext((_, { headers }) => {
  // ローカルストレージからトークンを取得
  const authData = localStorage.getItem("print_system_auth");
  let token = "";

  if (authData) {
    const parsedAuth = JSON.parse(authData);
    token = parsedAuth.token;
  }

  // トークンがあればヘッダーに追加
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
